import { useCallback } from "react";
import { putRequest } from "../utils/axiosClient";
import { toaster } from "../utils/toast";
import Constants from "../Constants";

const useRemoveRecord = ({ recordType, successMessage, onSuccess }) => {
    const removeFile = useCallback(async (fileToRemove) => {
        try {
            await putRequest({
                url: Constants.ApiUrl.records.remove,
                data: { s3Path: fileToRemove.s3UrlPath },
            });
            await onSuccess?.();
            toaster({ message: successMessage, success: true });
        } catch (error) {
            toaster({ message: error.message, success: false });
            console.error('Error removing record:', error);
        }
    }, [recordType, successMessage, onSuccess]);

    return { removeFile };
};

export default useRemoveRecord;
